import React from 'react';
import BgImage from './bg_image';
import BgVideo from './bg_video';

/**
 * Renders the background media component based on the provided media parameters.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.mediaParams - The media parameters.
 * @returns {JSX.Element} The rendered background media component.
 */

const BgMedia = ({ mediaParams }) => {
  const { filename, zIndex } = mediaParams.backgroundMedia;
  const { imageId } = mediaParams;

  const isImage = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
    const extension = getExtension(url);

    return imageExtensions.includes(extension);
  };

  const isVideo = (url) => {
    const videoExtensions = ['mp4', 'webm', 'ogg'];
    const extension = getExtension(url);

    return videoExtensions.includes(extension);
  };

  const renderMedia = (url) => {
    if (isImage(url) || imageId) {
      return (
        <BgImage
          imgParams={{
            ...mediaParams.backgroundMedia,
            ...mediaParams,
          }}
          zIndex={zIndex || 'z-0'}
        />
      );
    } else if (isVideo(url)) {
      return <BgVideo videoParams={mediaParams} />;
    } else {
      return <div></div>;
    }
  };

  return renderMedia(filename);
};

export default BgMedia;

export const getExtension = (url) => {
  if (!url) return null;
  return url.substring(url.lastIndexOf('.') + 1).toLowerCase();
};
